import { HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IWebUser } from '@Authentication/web-user/web-user-authentication.model';
import { environment } from '@environments/environment';
import { ApiService } from '@Services/api.service';
import { CodeService } from '@Services/code.service';
import { UsermenuService } from '../../usermenu/usermenu-extras/usermenu.service';
import { IWebUserAccess, IWebUserSearchObj, IWebUserSearchResponse } from './webuser.interface';

@Injectable({
  providedIn: 'root',
})
export class WebUsersService {
  URL = environment.gatewayBaseURL + '';
  retryCount = 1;
  noRetry = 0;

  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
    }),
  };

  constructor(
    private apiService: ApiService,
    public codeS: CodeService,
    private userMenuService: UsermenuService,
  ) {}

  searchWebUsers(query: IWebUserSearchObj) {
    return this.apiService.get<IWebUserSearchResponse>(`${this.URL}/web/access/search`, query);
  }

  getWebUserByUsername(userName: string, access = environment.accessType) {
    return this.apiService.get<IWebUser>(`${this.URL}/web/access/${userName}/${access}`);
  }

  createWebUser(createUser: any) {
    return this.apiService.post<IWebUserAccess>(`${this.URL}/web/access`, createUser);
  }

  updateWebUser(id: number, user: any) {
    return this.apiService.put<IWebUserAccess>(`${this.URL}/web/access/${id}`, user);
  }
}
